export const BD_map= (resolve, reject) =>{
  var geolocation = new BMap.Geolocation();
  var gc = new BMap.Geocoder();
  return new Promise((resolve,reject)=>{
    geolocation.getCurrentPosition(function (r) {
      var pt = r.point;
      pt.lng  //经度
      pt.lat  //纬度

      if (this.getStatus() == BMAP_STATUS_SUCCESS) {
        if (r.accuracy == null) {		//用户未开启定位功能

        } else {	//用户开启定位功能
          gc.getLocation(pt, function (rs) {
            var addComp = rs.addressComponents		//当前位置的具体信息:XX省(市)XX市XX区(县)
            addComp.province	//省
            addComp.city			//市
            addComp.district		//街道
          })
        }
      }
      resolve(pt)
    }, {
      enableHighAccuracy : true,
      timeout : 1000
    });
  });

}



// WEBPACK FOOTER //
// ./src/baidu-map.js